import React, { useEffect, useState } from "react";
import developerApi from "../api/developerApi";
import "./EnterprisesPage.css";

const getFormatHint = (formatName) => {
    const hints = {
        GoogleDrive: "Файловый источник через Google Drive",
        Vetmanager: "API-интеграция Vetmanager",
        Checkbox: "API-формат Checkbox",
        Rozetka: "XML / feed-поток Rozetka",
        Prom: "Prom feed / API",
        Bioteca: "AINUR API / несколько магазинов",
        DSN: "XML feed DSN",
        HProfit: "XML feed HProfit",
        Biotus: "XML feed Biotus",
        JetVet: "Google Drive / файловый обмен",
        ComboKeyCRM: "Feed / public key / URL",
        KeyCRM: "Интеграция с KeyCRM",
        Dntrade: "Маршрутизация по store",
        Ftp: "Файловый обмен по FTP",
        FtpMulti: "Несколько файлов по FTP",
        FtpZoomagazin: "FTP Zoomagazin",
        TorgsoftGoogle: "Torgsoft через Google Drive",
        TorgsoftGoogleMulti: "Несколько магазинов через Google Drive",
        FTPTabletki: "Импорт через FTP Tabletki",
        Business: "Business / dropship",
        Blank: "Отключённый / пустой формат",
        Unipro: "Входящая интеграция",
    };

    return hints[formatName] || "Формат данных";
};

const FormatsPage = ({ embedded = false }) => {
    const [formats, setFormats] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [addError, setAddError] = useState("");
    const [newFormat, setNewFormat] = useState("");

    const loadFormats = async () => {
        setLoading(true);
        setError("");
        try {
            const data = await developerApi.getDataFormats();
            const sorted = [...data].sort((a, b) => a.format_name.localeCompare(b.format_name));
            setFormats(sorted);
        } catch (err) {
            console.error("Ошибка загрузки реестра форматов:", err);
            setError("Не удалось загрузить реестр форматов.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadFormats();
    }, []);

    const handleAddFormat = async (event) => {
        event.preventDefault();
        setAddError("");
        const normalized = newFormat.trim();
        if (!normalized) {
            return;
        }

        try {
            await developerApi.addDataFormat({ format_name: normalized });
            setNewFormat("");
            await loadFormats();
        } catch (err) {
            console.error("Ошибка добавления формата:", err);
            setAddError("Не удалось добавить формат.");
        }
    };

    return (
        <div className="ent-page">
            {!embedded && (
                <div className="ent-card" style={{ padding: "20px 24px" }}>
                    <h1 style={{ margin: 0, fontSize: "26px" }}>Форматы данных</h1>
                </div>
            )}

            <div className="ent-card ent-toolbar">
                <div className="th">
                    <div>
                        <h2>Форматы данных</h2>
                        <p>Реестр форматов интеграции — определяет, какие поля показываются в карточке предприятия и как строится синхронизация каталога и остатков.</p>
                    </div>
                </div>
            </div>

            <div className="ent-split">
                <aside className="ent-card ent-picker">
                    <h2>Добавить формат</h2>
                    <form onSubmit={handleAddFormat} style={{ display: "grid", gap: "12px" }}>
                        <div className="ent-fld">
                            <label>Название формата</label>
                            <input
                                className="ent-inp"
                                type="text"
                                value={newFormat}
                                onChange={(e) => setNewFormat(e.target.value)}
                                placeholder="Например: NewFormat"
                            />
                        </div>
                        {addError ? <div className="ent-msg err">{addError}</div> : null}
                        <button type="submit" className="ent-btn ent-btn-primary ent-btn-block">
                            Добавить формат
                        </button>
                    </form>
                </aside>

                <section className="ent-card" style={{ overflow: "hidden" }}>
                    <div className="ent-toolbar" style={{ borderBottom: "1px solid var(--ent-border)" }}>
                        <div className="th">
                            <div>
                                <h2 style={{ fontSize: "15px" }}>Список форматов</h2>
                                <p>{formats.length} формат(ов) в реестре.</p>
                            </div>
                            <div className="acts">
                                <button type="button" className="ent-btn ent-btn-ghost ent-btn-sm" onClick={loadFormats}>Обновить</button>
                            </div>
                        </div>
                    </div>

                    {loading ? (
                        <div className="ent-empty">Загрузка форматов…</div>
                    ) : error ? (
                        <div className="ent-empty ent-msg err">{error}</div>
                    ) : formats.length === 0 ? (
                        <div className="ent-empty">Форматы пока не найдены.</div>
                    ) : (
                        <div className="ent-tbl-wrap" style={{ border: 0, borderRadius: 0 }}>
                            <table className="ent-tbl">
                                <thead>
                                    <tr>
                                        <th>Формат</th>
                                        <th>Подсказка</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {formats.map((format) => (
                                        <tr key={format.id || format.format_name}>
                                            <td className="strong">{format.format_name}</td>
                                            <td>{getFormatHint(format.format_name)}</td>
                                            <td><span className={format.format_name === "Blank" ? "ent-pill off" : "ent-pill"}>формат</span></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </section>
            </div>
        </div>
    );
};

export default FormatsPage;
